import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";

import Loader2 from "../../elements/Loader2";
import commoncss from "../../css/common.module.css";
import createRegCss from "../../css/createregister.module.css";
import buttoncss from "../../css/button.module.css";
import InputGroup from "../../elements/InputGroup";
import Breadcrumb from "../../components/Breadcrumb";
import { useParams } from "react-router-dom";
import accountant from "../../../../src/assets/signIn.svg";
import ApproverLeaseModal from "../leases/ApproverLeaseModal";
import { useHistory } from "react-router";
import { ReactComponent as DownArrow } from "../../assets/icons/down-arrow.svg";
import { editInvestmentRegisterAPI, getInvestmentRegisterForms } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import swal from "sweetalert";

const getCompanyOption = (company) => ({
  label: company?.company_name || company?.name || company?.label || "",
  value: company?._id || company?.companyID || company?.value || "",
});

const normalizeSelectedCompanies = (record = {}, companyOptions = []) => {
  if (Array.isArray(record?.linkedCompaniesData) && record.linkedCompaniesData.length) {
    return record.linkedCompaniesData
      .map(getCompanyOption)
      .filter((company) => company.value && company.label);
  }

  if (Array.isArray(record?.linkedCompanies) && record.linkedCompanies.length) {
    return record.linkedCompanies
      .map((companyId) => {
        const matchedCompany = companyOptions.find((opt) => opt.value === companyId);
        if (matchedCompany) return matchedCompany;
        return { label: String(companyId), value: companyId };
      })
      .filter((company) => company.value);
  }

  return [];
};

const EditInvestmentRegister = ({
  companyOptions = [],
  registerData = {},
  onSave,
  onSendForApproval,
}) => {
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const { registerid, id } = useParams();
  const investmentID = registerid || id;

  const [loader, setLoader] = useState(false);
  const [regName, setRegName] = useState(registerData?.name || "");
  const [selectedCompanies, setSelectedCompanies] = useState(
    registerData?.linkedCompanies || []
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [approverId, setApproverId] = useState(null);
  const [approverLeaseModal, setApproverLeaseModal] = useState(false);
  const [isApprovalPending, setIsApprovalPending] = useState(
    registerData?.approvalStatus?.includes("pending") || false
  );

  const dropdownRef = useRef(null);
  const fetchedInvestmentRef = useRef(null);

  // Sync state if registerData prop changes
  useEffect(() => {
    if (registerData?.name) setRegName(registerData.name);
    if (registerData?.linkedCompanies)
      setSelectedCompanies(registerData.linkedCompanies);
    if (registerData?.approvalStatus)
      setIsApprovalPending(registerData.approvalStatus.includes("pending"));
  }, [registerData]);

  useEffect(() => {
    const handler = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target))
        setDropdownOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  
const handleSave = async () => {
  if (!investmentID) {
    console.error("[EditInvestmentRegister] Missing investmentID on save");
    swal("Error", "Invalid register ID. Please refresh and try again.", "error");
    return;
  }

  const payload = {
    name: regName?.trim(),
    linkedCompanies: selectedCompanies.map((c) => c.value).filter(Boolean),
  };

  try {
    console.log("[EditInvestmentRegister] PATCH payload:", payload);
    const res = await editInvestmentRegisterAPI(investmentID, payload);
    if (res.status === 200) {
      swal("Success", "Investment Register updated successfully", "success");
      history.push("/dashboard"); 
    }
  } catch (error) {
    console.error("[EditInvestmentRegister] Update failed:", error);
    swal("Error", "Failed to update Investment Register", "error");
  }
};

  const handleSendForApproval = (approverID) => {
    const payload = {
      id: investmentID,
      name: regName,
      linkedCompanies: selectedCompanies.map((c) => c.value),
      approvalStatus: "pending approval",
      approverID: approverID,
    };
    if (onSendForApproval) onSendForApproval(payload);
    setApproverLeaseModal(false);
  };

  const allSelected =
    companyOptions.length > 0 &&
    selectedCompanies.length === companyOptions.length;

  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedCompanies([]);
    } else {
      setSelectedCompanies([...companyOptions]);
    }
  };

  const isFormValid = regName?.trim() && selectedCompanies.length > 0;

  const breadcrumbItems = [
    {
      label: "Home",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Edit Register",
      link: `/dashboard`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Edit Investment", link: "", className: "headerLable" },
  ];

useEffect(() => {
  const fetchData = async () => {
    if (!investmentID) {
      console.error("[EditInvestmentRegister] Missing investmentID in route params", {
        registerid,
        id,
      });
      return;
    }

    if (fetchedInvestmentRef.current === investmentID) {
      return;
    }

    try {
      setLoader(true);
      fetchedInvestmentRef.current = investmentID;
      console.log("[EditInvestmentRegister] Fetching form data for investmentID:", investmentID);
      const res = await getInvestmentRegisterForms(investmentID);
      const data =
        res?.data?.investmentRegister ||
        res?.data?.data?.investmentRegister ||
        res?.data?.result?.investmentRegister ||
        {};

      setRegName(data?.name || "");
      setSelectedCompanies(normalizeSelectedCompanies(data, companyOptions));
      console.log("[EditInvestmentRegister] Prefill data loaded:", data);

    } catch (error) {
      fetchedInvestmentRef.current = null;
      console.error("[EditInvestmentRegister] Error fetching data:", error);
      swal("Error", "Failed to load Investment Register data", "error");
    } finally {
      setLoader(false);
    }
  };

  fetchData();
}, [investmentID]);

  return (
    <>
      <div className="conatiner">
        {loader && <Loader2 />}

        <motion.div
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.imgContainer}
        >
          <img
            src={accountant}
            alt="accountant working"
            style={{ height: "93.7vh", placeSelf: "center" }}
          />
        </motion.div>

        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={createRegCss.formContainer}
        >
          <div className={commoncss.dFlexJustifysb} style={{ marginTop: "20px" }}>
            <Breadcrumb
              style="margin-right:auto"
              items={breadcrumbItems}
              headerActions={<></>}
            />
          </div>

          <motion.div
            initial={{ x: 400, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.7, ease: "easeInOut" }}
          >
            <div className={createRegCss.alignForm}>
              <div className={createRegCss.container2}>
                <div className={`${commoncss.dFlex} mb-3`} style={{ marginTop: "30px" }}>
                  <div
                    className={commoncss.dFlexClm}
                    style={{ alignItems: "center" }}
                  >
                    <span className={createRegCss.heading1}>
                      Edit Investment Register
                    </span>
                    <span className={createRegCss.label1}>
                      Edit register name and linked companies
                    </span>
                  </div>
                </div>

                <div className={`${createRegCss.container3} mt-3 mb-1`}>

                  {/* Register Name */}
                  <InputGroup
                    label="Name of Investment Register"
                    inputs={[
                      <input
                        key="reg-name"
                        name="invreg_name"
                        placeholder="Investment register"
                        type="text"
                        value={regName}
                        onChange={(e) => setRegName(e.target.value)}
                        disabled={isApprovalPending}
                      />,
                    ]}
                  />

                  {/* Linked Companies Multi-select */}
                  <div className="mt-3" style={{ width: "100%" }}>
                    <label
                      style={{
                        fontSize: "13px",
                        fontWeight: 500,
                        color: "#444",
                        marginBottom: "6px",
                        display: "block",
                      }}
                    >
                      Select Linked Companies
                    </label>

                    <div
                      key="company-select"
                      ref={dropdownRef}
                      style={{ position: "relative", width: "100%" }}
                    >
                        {/* Trigger */}
                        <div
                          onMouseEnter={() => setShowTooltip(true)}
                          onMouseLeave={() => setShowTooltip(false)}
                          onClick={() =>
                            !isApprovalPending && setDropdownOpen((o) => !o)
                          }
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "0 12px",
                            border: "1px solid #C2E6D1",
                            borderRadius: "10px",
                            backgroundColor: isApprovalPending ? "#f0f0f0" : "#F4FAF5",
                            cursor: isApprovalPending ? "not-allowed" : "pointer",
                            minHeight: "40px",
                            fontFamily: "DM Sans, sans-serif",
                            fontSize: "13px",
                            color: "#183930",
                            width: "100%",
                            boxSizing: "border-box",
                            position: "relative"
                          }}
                        >
                          <span
                            style={{
                              color: selectedCompanies.length === 0 ? "#9CA3AF" : "#183930",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "85%",
                              display: "block",
                            }}
                          >
                            {selectedCompanies.length === 0
                              ? "Select Companies"
                              : selectedCompanies.map((c) => c.label).join(", ")}
                          </span>
                          {!isApprovalPending && (
                            <DownArrow
                              style={{
                                transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "transform 0.2s",
                              }}
                            />
                          )}

                          {showTooltip && !dropdownOpen && selectedCompanies.length > 0 && (
                            <div
                              style={{
                                position: "absolute",
                                top: "100%",
                                left: "0",
                                marginTop: "8px",
                                backgroundColor: "#000000",
                                color: "#ffffff",
                                padding: "8px 12px",
                                borderRadius: "6px",
                                fontSize: "14px",
                                width: "100%",
                                boxSizing: "border-box",
                                zIndex: 1000,
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                lineHeight: "1.4"
                              }}
                            >
                              {selectedCompanies.map((c) => c.label).join(", ")}
                            </div>
                          )}
                        </div>

                        {/* Dropdown Options */}
                        {dropdownOpen && !isApprovalPending && (
                          <div
                            style={{
                              position: "absolute",
                              top: "calc(100% + 4px)",
                              left: 0,
                              right: 0,
                              backgroundColor: "#fff",
                              border: "1px solid #C2E6D1",
                              borderRadius: "10px",
                              boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
                              zIndex: 999,
                              maxHeight: "200px",
                              overflowY: "auto",
                            }}
                          >
                            {/* Select All — inside dropdown, only visible when open */}
                            <div
                              onClick={handleSelectAll}
                              style={{
                                padding: "10px 14px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                fontWeight: 600,
                                fontSize: "13px",
                                background: "#ffffff",
                                position: "sticky",
                                top: 0,
                                zIndex: 1,
                                borderBottom: "1px solid #C2E6D1",
                              }}
                            >
                              <input
                                type="checkbox"
                                readOnly
                                checked={allSelected}
                                style={{ accentColor: "#2d6a4f", cursor: "pointer" }}
                              />
                              Select all companies
                            </div>

                            {companyOptions.map((opt) => {
                              const selected = !!selectedCompanies.find(
                                (v) => v.value === opt.value
                              );
                              return (
                                <div
                                  key={opt.value}
                                  onClick={() => {
                                    if (selected) {
                                      setSelectedCompanies(
                                        selectedCompanies.filter((v) => v.value !== opt.value)
                                      );
                                    } else {
                                      setSelectedCompanies([...selectedCompanies, opt]);
                                    }
                                  }}
                                  style={{
                                    padding: "10px 14px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    fontSize: "13px",
                                    background: selected ? "#fff" : "#fff",
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    readOnly
                                    checked={selected}
                                    style={{ accentColor: "#2d6a4f", cursor: "pointer" }}
                                  />
                                  {opt.label}
                                </div>
                              );
                            })}
                          </div>
                        )}

                        {/* Outside Select All */}
                        {!dropdownOpen && !isApprovalPending && (
                          <div
                            onClick={handleSelectAll}
                            style={{
                              padding: "10px 0",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              fontWeight: 500,
                              fontSize: "14px",
                              background: "transparent",
                            }}
                          >
                            <input
                              type="checkbox"
                              readOnly
                              checked={allSelected}
                              style={{ accentColor: "#2d6a4f", cursor: "pointer" }}
                            />
                            Select all companies
                          </div>
                        )}

                        {/* Chips */}
                        {selectedCompanies.length > 0 && (
                          <div
                            style={{
                              maxHeight: "250px",
                              overflowY: "auto",
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "8px",
                              background:
                                selectedCompanies.length > 3 ? "#f8f9f9" : "#ffffff",
                              padding: "10px",
                              borderRadius: "10px",
                              border:
                                selectedCompanies.length > 3
                                  ? "1px solid #e0e0e0"
                                  : "none",
                              width: "100%",
                              boxSizing: "border-box",
                              marginTop: "10px"
                            }}
                          >
                            {selectedCompanies.map((opt) => (
                              <div
                                key={opt.value}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: "8px",
                                  padding: "8px 10px",
                                  border: "0.8px solid #C2E6D1",
                                  borderRadius: "6px",
                                  backgroundColor: "#fff",
                                  fontFamily: "DM Sans, sans-serif",
                                  fontSize: "13px",
                                  color: "#183930",
                                }}
                              >
                                {opt.label}
                                {!isApprovalPending && (
                                  <span
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedCompanies(
                                        selectedCompanies.filter((v) => v.value !== opt.value)
                                      );
                                    }}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#B3C0BD",
                                    }}
                                  >
                                    <svg
                                      width="12"
                                      height="12"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                    >
                                      <line x1="2" y1="2" x2="12" y2="12" />
                                      <line x1="12" y1="2" x2="2" y2="12" />
                                    </svg>
                                  </span>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                  </div>

                  {/* Action Buttons */}
                  <div
                    className="mt-4"
                    style={{ width: "70%", placeSelf: "center" }}
                  >
                    {user?.isAdmin === "Yes" && (
                      <button
                        type="submit"
                        className={`${buttoncss.primary} ${
                          !isFormValid ? buttoncss.disabledBtn : ""
                        }`}
                        style={{
                          padding: "7px",
                          width: "100%",
                          borderRadius: "12px",
                        }}
                        disabled={!isFormValid}
                        onClick={handleSave}
                      >
                        Save Changes
                      </button>
                    )}

                    {user?.responsibilities === "preparer" && (
                      <button
                        type="submit"
                        className={`${buttoncss.primary} ${
                          !isFormValid || isApprovalPending
                            ? buttoncss.disabledBtn
                            : ""
                        }`}
                        style={{
                          padding: "7px",
                          width: "100%",
                          borderRadius: "12px",
                        }}
                        onClick={() => {
                          if (isFormValid && !isApprovalPending)
                            setApproverLeaseModal(true);
                        }}
                        disabled={!isFormValid || isApprovalPending}
                      >
                        Send changes for approval
                      </button>
                    )}
                  </div>

                  {approverLeaseModal && (
                    <ApproverLeaseModal
                      setApproverLeaseModal={setApproverLeaseModal}
                      companyId={
                        selectedCompanies.length > 0
                          ? selectedCompanies[0].value
                          : null
                      }
                      setApproverId={setApproverId}
                      sendForApproval={handleSendForApproval}
                    />
                  )}
                </div>
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </>
  );
};

export default EditInvestmentRegister;